import { render, staticRenderFns } from "./FaceTopMatter.vue?vue&type=template&id=54e37f7b"
import script from "./FaceTopMatter.vue?vue&type=script&lang=ts"
export * from "./FaceTopMatter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports